
import { defineComponent } from "vue";

import { BaseInput, BaseIcon } from "components/atoms";
import { iconN } from "assets/icons";

export default defineComponent({
  name: "InputField",
  components: { BaseInput, BaseIcon },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String as () => iconN,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
    showRequiredWarning: {
      type: Boolean,
      default: false,
    },
    validationStatus: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    const handleOnBlur = () => emit("on-blur");

    return {
      handleOnBlur,
      emit,
    };
  },
  emits: ["on-blur", "update:modelValue"],
});
